import { canUseDOM, cookie } from '@pmi/pmi-iqos-shared-react'

const noop = () => {}

export class IqosphereAnalyticsManager {
  constructor(dataLayer) {
    this.dataLayer = dataLayer || []
  }

  digitalPassEvent = label => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'gtmZoneEventMicrosites',
      eventCategory: 'Digital Pass Event',
      eventAction: 'Click',
      eventLabel: label,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  myProfilePrizesClick = label => {
    const dataLayer = this.dataLayer
    const data = {
      event: 'gtmZoneEventMicrosites',
      eventCategory: 'My Account',
      eventAction: 'Click',
      eventLabel: label,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }

  onContinueMissionQuiz = eventLabel => {
    const dataLayer = this.dataLayer

    const data = {
      event: 'gtmZoneEventMicrosites',
      eventCategory: 'TX Mission',
      eventAction: 'Click',
      eventLabel,
      user_id: cookie.getSpiceId() || ''
    }

    dataLayer ? dataLayer.push(data) : noop()
  }
}

export default new IqosphereAnalyticsManager(
  canUseDOM ? window.dataLayer : null
) // set by google tag manager
